import { Descriptions, Space, Tag, Typography } from "antd";
const { Text } = Typography;

const OperationsDetails = ({ data }) => {
  function yesNo(v) {
    return v === true ? "Yes" : v === false ? "No" : "—";
  }

  return (
    <Descriptions bordered size="small" column={2}>
      <Descriptions.Item label="Flying Outside Canada">
        {yesNo(data.flying_outside_canada)}
      </Descriptions.Item>
      <Descriptions.Item label="Trips / Year (Leaving Canada)">
        {data.leaving_canada_amount ?? "-"}
      </Descriptions.Item>

      <Descriptions.Item label="Areas (Outside Canada)" span={2}>
        {data.aircraft_flying?.length ? (
          <Space wrap>
            {data.aircraft_flying.map((a, i) => (
              <Tag key={`${a}-${i}`}>{a}</Tag>
            ))}
          </Space>
        ) : (
          <Text>-</Text>
        )}
        {data.other_listed_area ? (
          <div style={{ marginTop: 6 }}>
            <Text type="secondary">Other:&nbsp;</Text>
            <Text>{data.other_listed_area}</Text>
          </div>
        ) : null}
      </Descriptions.Item>

      <Descriptions.Item label="Longest Trip">
        {data.trip_duration_amount && data.trip_duration_select
          ? `${data.trip_duration_amount} ${data.trip_duration_select}`
          : "-"}
      </Descriptions.Item>
      <Descriptions.Item label="Airshows">
        {yesNo(data.airshows_checkbox)}
        {data.airshows_input ? ` • ${data.airshows_input}` : ""}
      </Descriptions.Item>

      <Descriptions.Item label="Aerobatics">
        {yesNo(data.aircraft_for_aerobatics_checkbox)}
        {data.aircraft_for_aerobatics_input
          ? ` • ${data.aircraft_for_aerobatics_input}`
          : ""}
      </Descriptions.Item>
      <Descriptions.Item label="Off-Airport Landings">
        {yesNo(data.landing_off_airport_checkbox)}
        {data.landing_off_airport_input
          ? ` • ${data.landing_off_airport_input}`
          : ""}
      </Descriptions.Item>

      <Descriptions.Item label="Shoulder Harnesses">
        {yesNo(data.shoulder_harnesses_checkbox)}
      </Descriptions.Item>
    </Descriptions>
  );
};

export default OperationsDetails;
